import { isDevelopment } from './env';
import { getQueryString } from './uri';

const paramLanguage = getQueryString('lang'); // en 英文 zh 中文
const language = window.navigator.language;

export const isLanguageEn = isDevelopment
  ? paramLanguage
    ? paramLanguage === 'en'
    : language.includes('en')
  : paramLanguage
    ? paramLanguage === 'en'
    : language.includes('en');
